import '../vendor'

import 'lazysizes/plugins/object-fit/ls.object-fit'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'

import '../utils/array-from-polyfill'
import '../utils/class-list-polyfill'
import '../utils/closest-polyfill'
import '../utils/includes-polyfill'
import '../utils/object-fit-polyfill'

import '../utils/focus-ring'
import '../utils/svgforeverybody'

import '../../styles/theme.css'
import { getElements } from '../utils/functional'
import { externalLinks, wrapIframes, wrapTables } from '../utils'

import $ from 'jquery'

window.slate = window.slate || {}
window.theme = window.theme || {}
window.$ = $
window.jQuery = $

// window.ShopifyAPI = cart

document.addEventListener('DOMContentLoaded', () => {
  externalLinks()
  wrapTables({
    elements: getElements('.rte-RichText table')
  })
  wrapIframes({
    elements: getElements('.rte-RichText iframe')
  })
  getElements('[data-module]').forEach(el => {
    const name = el.getAttribute('data-module')
    const Module = require(`../modules/${name}`).default
    new Module(el)
  })
  // If the device is iOS add a class to the body so we can do specific CSS for it
  if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    const body = document.body || document.documentElement

    const iPhoneVersion = () => {
      const iHeight = window.screen.height
      const iWidth = window.screen.width

      if (iWidth === 414 && iHeight === 896) {
        return 'Xmax-Xr'
      } else if (iWidth === 375 && iHeight === 812) {
        return 'X-Xs'
      } else if (iWidth === 320 && iHeight === 480) {
        return '4'
      } else if (iWidth === 375 && iHeight === 667) {
        return '6'
      } else if (iWidth === 414 && iHeight === 736) {
        return '6+'
      } else if (iWidth === 320 && iHeight === 568) {
        return '5'
      } else if (iHeight <= 480) {
        return '2-3'
      }

      return 'none'
    }

    body.classList.add('is-iOS')
    body.classList.add(`is-iPhone-${iPhoneVersion()}`)

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    const isIosChrome = !!navigator.userAgent.match('CriOS')

    if (isSafari) {
      body.classList.add('is-Safari')
    }

    if (isIosChrome) {
      body.classList.add('is-Chrome')
    }
  }
})

$(function () {
  ajaxCart.init({
    formSelector: '[action="/cart/add"]',
    cartContainer: '#CartContainer',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '.cartCount',
    cartCostSelector: '#CartCost',
    moneyFormat: theme.moneyFormat
  })

  ajaxCart.load()
})

/****
 * Setup CSS Grid & CSS Vars fallbacks
 ****/
const body = document.body || document.documentElement
body.classList.add('util-JSEnabled')

if ('grid' in body.style === false) {
  require(`../utils/css-grid-fallback`)
  body.className += ' util-NoGrid'
}

function hasNativeCSSProperties () {
  const opacity = '0'
  const el = body
  // Setup CSS properties.
  el.style.setProperty('--test-opacity', opacity)
  el.style.setProperty('opacity', 'var(--test-opacity)')
  // Feature detect then remove all set properties.
  const hasNativeCSSProperties = window.getComputedStyle(el).opacity === opacity
  el.style.setProperty('--test-opacity', '')
  el.style.opacity = ''
  return hasNativeCSSProperties
}

if (hasNativeCSSProperties() === false) {
  require(`../utils/vars-fallback`)
  body.className += ' util-NoVars'
}
